import * as React from 'react'
import { images } from '../../theme'

export const LogoWithText = ({ className }: { className?: string }) => (
  <div className={`flex items-center justify-center ${className ?? ''}`}>
    <img src={images.logo} alt="Logo" className="h-[30px] w-auto mr-1.5" />
    <span className="text-lg font-semibold tracking-wide">SZUKADŁO</span>
  </div>
)
